@if (CompanyVendor && Vendor && CompanyId && VendorId && action) {
  <div class="container-fluid h-100">
    <!-- Page head: VIVE Vetting eyebrow + vendor name + current step -->
    <div class="row align-items-center mb-3">
      <div class="col">
        <div class="review-eyebrow">
          VIVE Vetting · {{ CurrentComplianceStep }} review
        </div>
        <h2 class="mb-0">
          <a
            href="javascript:void(0)"
            class="review-vendor-link"
            (click)="onVendorNameClick()"
          >
            {{ Vendor.legalName }}
          </a>
        </h2>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <div class="row">
          <div class="col g-0">
            <app-client-vendor-compliance-info
              [CompanyVendor]="CompanyVendor"
              [CompanyId]="CompanyId"
              [VendorId]="VendorId"
              [SharedOperationStates]="SharedOperationStates"
              [CurrentComplianceStep]="CurrentComplianceStep"
            ></app-client-vendor-compliance-info>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col g-0">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>

      <!-- Right rail: progress tracker + grouped reviewer actions -->
      <div class="col-3">
        <app-compliance-tracker
          [CompanyVendorId]="CompanyVendorId"
          [CompanyVendor]="CompanyVendor"
          [allowSelection]="true"
          [action]="action"
          [CurrentComplianceProgress]="CurrentComplianceProgress"
          [(CurrentComplianceStep)]="CurrentComplianceStep"
        ></app-compliance-tracker>

        <!-- Primary daily-use actions -->
        @if (CompanyVendor && !CompanyVendor.isArchived) {
          <div class="review-actions">
            <button
              type="button"
              class="btn btn-primary review-action"
              (click)="setReviewStatus()"
            >
              <i class="bi bi-flag me-2"></i>Set review status
            </button>
            <button
              type="button"
              class="btn btn-outline review-action"
              (click)="markVsaAsSigned()"
            >
              <i class="bi bi-pen me-2"></i>Mark VSA as signed
            </button>
            @if (CurrentComplianceStep) {
              <button
                type="button"
                class="btn btn-outline review-action"
                (click)="createTicket()"
              >
                <i class="bi bi-ticket me-2"></i>Create ticket
              </button>
            }
          </div>
        }

        <!-- Reference / tools -->
        <div class="review-actions">
          <button
            type="button"
            class="btn btn-outline review-action"
            (click)="onDocumentsNotesClick()"
          >
            <i class="bi bi-file-text me-2"></i>Documents &amp; notes
          </button>
          <button
            type="button"
            class="btn btn-outline review-action"
            (click)="copyRegistrationURL()"
          >
            <i class="bi bi-clipboard me-2"></i>Copy registration URL
          </button>
          @if (CompanyVendor.viveStatus === 'Site Conditional') {
            <button
              type="button"
              class="btn btn-outline review-action"
              (click)="openVendorSiteAssignments()"
            >
              <i class="bi bi-geo-alt me-2"></i>Sites
            </button>
          }
          @if (CurrentComplianceStep === 'Insurance') {
            <button
              type="button"
              class="btn btn-outline review-action"
              (click)="downloadInsuranceRequirements()"
            >
              <i class="bi bi-download me-2"></i>Client insurance requirements
            </button>
          }
        </div>

        <!-- Configuration / state changes -->
        @if (CompanyVendor && !CompanyVendor.isArchived) {
          <div class="review-actions">
            @if (CompanyVendor.VendorId) {
              <button
                type="button"
                class="btn btn-outline review-action"
                (click)="selectComplianceType()"
              >
                <i class="bi bi-arrow-repeat me-2"></i>Change compliance type
              </button>
            }
            <button
              type="button"
              class="btn btn-outline review-action"
              (click)="toggleAutoLink()"
            >
              <i class="bi bi-link-45deg me-2"></i>
              {{ CompanyVendor.allowEinAutoLink ? 'Disable' : 'Enable' }} EIN
              auto-link
            </button>
            @if (!CompanyVendor.vendorLastDatePaid) {
              <button
                type="button"
                class="btn btn-outline review-action"
                (click)="convertVendorToComplianceExempt()"
              >
                <i class="bi bi-shield-check me-2"></i>Convert to compliance
                exempt
              </button>
            }
            @if (canConvertVendorToClientRegisteredVendor) {
              <button
                type="button"
                class="btn btn-outline review-action"
                (click)="convertVendorToClientRegistered()"
              >
                <i class="bi bi-arrow-right-circle me-2"></i>
                Convert to
                {{
                  Company?.allowAutomatedBusinessVerificationClientRegisteredVendors
                    ? 'business verified'
                    : 'non-verified'
                }}
              </button>
            }
          </div>
        }

        <!-- Destructive -->
        @if (CompanyVendor && !CompanyVendor.isArchived) {
          <div class="review-actions">
            <button
              type="button"
              class="btn btn-outline review-action review-action--danger"
              (click)="archiveClientVendor()"
            >
              <i class="bi bi-archive me-2"></i>Archive client vendor
            </button>
          </div>
        }
      </div>
    </div>
  </div>
}
